// src/ai/HostSpeechQueue.js
export default class HostSpeechQueue {
  constructor({ duck = null } = {}) {
    this.q = [];
    this.speaking = false;
    this.duck = duck; // { down:()=>void, up:()=>void } optional
  }
  enqueue(text, { priority = 5, expiresMs = 8000 } = {}) {
    if (!text || !text.trim()) return;
    const item = { text: text.trim(), priority, t: Date.now(), expiresMs };
    this.q.push(item);
    this.q.sort((a, b) => b.priority - a.priority || a.t - b.t);
    this.pump();
  }
  cancelAll() { this.q = []; }

  async pump() {
    if (this.speaking) return;
    // remove expired
    const now = Date.now();
    this.q = this.q.filter(i => now - i.t < i.expiresMs);

    const next = this.q.shift();
    if (!next) return;

    this.speaking = true;
    try {
      this.duck?.down?.();
      await window.aiSpeak?.(next.text);
    } catch (_) {} finally {
      this.duck?.up?.();
      this.speaking = false;
      // schedule the next microtask to avoid call stack recursion
      setTimeout(() => this.pump(), 0);
    }
  }
}
